import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-nav-horizontal-1-6-0{margin:0 0 24px;padding:0}.hcr-nav-horizontal--centered-1-6-0{text-align:center}.hcr-nav-horizontal--right-1-6-0{text-align:right}.hcr-nav-horizontal--left-1-6-0{text-align:left}.hcr-nav-horizontal__items-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end;margin:0;padding:0}.hcr-nav-horizontal__item-1-6-0{position:relative;max-width:50%;text-align:center;list-style-type:none}.hcr-nav-horizontal__item-1-6-0:before{display:inline-block;position:absolute;bottom:12px;left:0;height:16px;border-left:1px solid #e1e1e1;content:\"\"}.hcr-nav-horizontal__item-1-6-0:first-child:before{display:none;content:none}.hcr-nav-horizontal__link-1-6-0{display:inline-block;width:100%;padding:9px 12px;color:#444;font-size:16px;font-weight:400;line-height:1.375em;text-decoration:none;cursor:pointer}.hcr-nav-horizontal__link-1-6-0:active,.hcr-nav-horizontal__link-1-6-0:focus,.hcr-nav-horizontal__link-1-6-0:hover,.hcr-nav-horizontal__link--active-1-6-0{color:#ffad00;text-decoration:none}.hcr-nav-horizontal__link-1-6-0:active:before,.hcr-nav-horizontal__link-1-6-0:focus:before,.hcr-nav-horizontal__link-1-6-0:hover:before,.hcr-nav-horizontal__link--active-1-6-0:before{display:block;position:absolute;right:0;bottom:0;left:0;height:0;border-bottom:4px solid #ffad00;content:\"\"}",
map:{"hcr-nav-horizontal":"hcr-nav-horizontal-1-6-0","hcr-nav-horizontal--centered":"hcr-nav-horizontal--centered-1-6-0","hcr-nav-horizontal--right":"hcr-nav-horizontal--right-1-6-0","hcr-nav-horizontal--left":"hcr-nav-horizontal--left-1-6-0","hcr-nav-horizontal__items":"hcr-nav-horizontal__items-1-6-0","hcr-nav-horizontal__item":"hcr-nav-horizontal__item-1-6-0","hcr-nav-horizontal__link":"hcr-nav-horizontal__link-1-6-0","hcr-nav-horizontal__link--active":"hcr-nav-horizontal__link--active-1-6-0"}};

var bem = Bem('nav-horizontal', styles);
var NavHorizontal = function NavHorizontal(_ref) {
  var children = _ref.children,
      content = _ref.content,
      extraClasses = _ref.extraClasses;
  var navItems = content || children; // renders actual link HTML element, changes it to <span> if no href provided

  var renderLinkHtml = function renderLinkHtml(href, active, text, restChild) {
    if (href) {
      return React.createElement("a", _extends({
        className: bem.e('link', {
          active: active
        }),
        href: href
      }, restChild), text);
    }

    return React.createElement("span", _extends({
      className: bem.e('link', {
        active: active
      })
    }, restChild), text);
  };

  return React.createElement("nav", {
    className: bem.b(false, extraClasses)
  }, React.createElement("ul", {
    className: bem.e('items')
  }, navItems.map(function (_ref2, i) {
    var text = _ref2.text,
        key = _ref2.key,
        active = _ref2.active,
        href = _ref2.href,
        RouterLink = _ref2.RouterLink,
        restChild = _objectWithoutProperties(_ref2, ["text", "key", "active", "href", "RouterLink"]);

    return React.createElement("li", {
      className: bem.e('item'),
      key: key || "".concat(text, " + ").concat(i)
    }, RouterLink ? React.createElement(RouterLink, _extends({
      to: href,
      className: bem.e('link'),
      activeClassName: bem.e('link', {
        active: true
      })
    }, restChild), text) : renderLinkHtml(href, active, text, restChild));
  })));
};
NavHorizontal.displayName = 'NavHorizontal';
NavHorizontal.defaultProps = {
  extraClasses: '',
  children: [],
  content: null
};
var contentProps = PropTypes.arrayOf(PropTypes.shape({
  /** Link text */
  text: PropTypes.node.isRequired,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Marks link as active */
  active: PropTypes.bool,

  /** custom link RouterLink, e.g. if you use ReactRouter or similar library */
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}));
NavHorizontal.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Nav items */
  children: contentProps,

  /** Nav items */
  content: contentProps // @todo deprecate content prop

};
var navHorizontal = Injecss(NavHorizontal, styles);

export { navHorizontal as NavHorizontal };
